import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { getClientProfileSettingsQueryKey } from './get-client-profile-settings'

type UpdateClientProfileSettingsRequest = {
  buildingId: number
  hiddenFields: string[]
}

const updateClientProfileSettings = async (data: UpdateClientProfileSettingsRequest) => {
  const response = await authAPI.put('/client/profile-settings', data)
  return response.data
}

export const useUpdateClientProfileSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateClientProfileSettings,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getClientProfileSettingsQueryKey({ buildingId: variables.buildingId }),
      })
    },
  })
}
